import { Component, Input, OnInit } from '@angular/core';
import { Constant } from 'src/app/constant/constant';


@Component({
  selector: 'calsoft-audios',
  templateUrl: './audios.component.html',
  styleUrls: ['./audios.component.scss']
})
export class AudiosComponent implements OnInit{

  @Input() value: any;
  cid: string;

  ngOnInit(): void {

    let values =localStorage.getItem(Constant.enterPriseKey);

    if(values!=null){

      this.cid="&cid="+values
    }
    
  }


}
